<template>
    <footer id="bottom-menu">
        <div id="inferior-menu" class="w-100">
            <div class="d-flex row w-100" >
                <div class="col-12 col-md-1 contenedor-logo separador" style="height: 10em;">
                    <img class="vertical-center logo" src="../../../assets/paginaoficial/Logotipo_Negativo_Vertical.png" />
                </div>
                <!--<div class="col-12 col-md-6 contenedor estilo" style="height: 10em;">
                    <ul class="vertical-center">
                        <li style="color:white" class="Myriad"><a target="blank" href="https://goo.gl/maps/L27vDRLym1cNcNVm6"><i class="fas fa-building"></i>&nbsp;Prueba Héroe de Nacozari Esq. Av. Lic. Adolfo López Mateos Ote S/N, San Luis, 20250 Aguascalientes, Ags.</a></li>
                        <li style="color:white" class="Myriad"><i class="fas fa-phone"></i>&nbsp;449 910 3550</li>
                        <li style="color:white" class="Myriad"><i class="fas fa-copyright"></i>&nbsp;{{anio}} - Todos los derechos reservados.</li>
                    </ul>
                </div>-->
                <div v-for="menu in menus" v-bind:key="menu.MenuId" class="col-12 col-md-5 contenedor-ligas">
                    <p style="color:white" class="enMayusculas">{{menu.Titulo}}</p>
                    <div class="row col-md-12 col-12 h-50 w-100">
                        <ul class="disminuir-fuente row h-100 w-100">
                            <li style="color:white" class="col-12 col-md-6" v-for="submenu in menu.Submenus" v-bind:key="submenu.SubmenuId">               
                                <a v-if="!submenu.SeMuestraEnVisor" :href="submenu.RutaParaAccesar" target="blank" class="sitios-interes">{{submenu.Titulo}}</a>
                                <a v-if="submenu.SeMuestraEnVisor" @click="AbreElVisor(submenu.RutaParaAccesar)" target="blank" class="sitios-interes">{{submenu.Titulo}}</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div v-if="this.PAGINA_DE_INICIO == 17" class="col-12 col-md-1 contenedor-logo aling-item-right" style="height: 10em;">
                    <img class="vertical-center logo" src="../../../assets/paginaoficial/qr_formulario_tribunal_diciplina.jpeg" />
                </div>  

                <div class="col-12 col-md-6 aling-item-right" style="height: 2em;">
                    <ul class="vertical-center" >
                        <li style="color:white" class="Myriad"><i class="fas fa-copyright"></i>&nbsp;{{anio}} - Todos los derechos reservados.</li>
                    </ul>
                </div>      
            </div>            
        </div>        
    </footer>
</template>

<script>
import enumeraciones from "@/../static/js/enumeraciones";
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
import api from "@/../static/js/api";
import axios from "axios";

export default {
    data() {
        return {
            enumeraciones,
            anio:'',
            enumeraciones_sicpo,
            PAGINA_DE_INICIO: 6,
            TIPO_POSICION: 2,
            menus: [],
            nombreDeVariableDelComponente: "cargoMenuInferior"
        };
    },
    computed: {
      existeAlgunMenuSeleccionado: function() {
        let seAbreElMenu = false; 
         console.log(">>>>existeAlgunMenuSeleccionado this.menu:",this.menu);
        if(this.menus.length > 0) {
          this.menus.forEach(menu => {
            if(menu.Mostrar == true)
              seAbreElMenu = true;
          })
        }

        return seAbreElMenu;
      },
      idPaginaInicial:function(){
          console.log(">>>>existeAlgunMenuSeleccionado idPaginaInicial:",this.$store.getters.Get_PaginaInicial_Micrositio);
          return this.$store.getters.Get_PaginaInicial_Micrositio;
      }      
    
    },
    methods: {
            AbreElVisor: function(vinculo) {  
       this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
      },
        async CargaMenu() {
        var paginaRoute = this.$store.getters.Get_SICPO_Micrositio_MenuRuta;
        console.log(">>>>CargaMenu paginaRoute: ",paginaRoute)
        console.log(">>>>CargaMenu PAGINA_DE_INICIO: ",this.PAGINA_DE_INICIO)
        this.PAGINA_DE_INICIO = paginaRoute == "/Micrositio/TD/Home"?17: this.PAGINA_DE_INICIO;
        let peticion = {
          Url: paginaRoute,
          conSubmenus:true,
          tipoPosicion:2,
          conSoloSubmenusActivos:true,
          EsPrueba: enumeraciones.EsPrueba
        }
        axios.post(api.conexion + api.SICPO.sistema.micrositioweb.oficialmicrositio.ObtenLosMenusYSubmenusDeMicrositio, peticion).
        then(async response => {
          if(response.data.SiHayError){
              this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Error);

          }else{
          this.menus = response.data.MenuMicrositio.menus;
          this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Cargado);

          }  

        }).catch(e => {
          console.log('Error de Pagina: ' + e)
           this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Error);
        }); 
      },
        CargaElMenu: function() {
           
            let parametros = {
                EsPrueba: this.enumeraciones.EsPrueba, 
                PaginaDeInicioId: this.idPaginaInicial, 
                TipoPosicionId: this.TIPO_POSICION
            }
            console.log(">>>>MenuInferior Parameters:",parametros)
            axios
                .post(api.conexion + api.SICPO.sistema.paginaweb.paginaoficial.ObtenLosMenusYSubmenusDeLaPaginaOficial, parametros)
                .then(respuesta => {
                if (respuesta.data.SiHayError) {
                    this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Error);
                } else {
                   
                    this.menus = respuesta.data.Menus;
                    this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
                }
            })
            .catch(excepcion => {
                console.error(excepcion);
                this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Error);
            });
        },
        YaTermineDeCargar: function(estatus) {
            this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, estatus);
        }
    }, 
    mounted() {
      this.CargaMenu();
        this.anio = moment().format('YYYY');
    }
}
</script>

<style scoped>
.sitios-interes{
    font-family: 'AntenaBeta';
    font-size: 14px;
}
.logo{
    width: 85%;
 
   

}
#bottom-menu {
    z-index: 9 !important;
    
}

.enMayusculas {
  text-transform: uppercase;
  font-family: 'AntenaBeta';
}
.AntenaBeta{
    font-family: 'AntenaBeta';
    
}
.Myriad{
    font-family:'Myriad';
    margin-right: 30px;
}
#inferior-menu {
    /* display: flex; */
    align-items: center;
    height: auto;
    font-size: 18px;
    background-color: rgb(0,117,115);
    /* z-index: 10 !important; */
    position: relative;
}

#inferior-menu div{
    height: 100%;
    /* background-color: rgb(128, 19, 19); */
}

a {
    color: #FFFFFF;
    margin-right: 0px;
}

a:hover {
  color: #be9a5e;
}

.separador {
    border-right: 2px solid white;
    padding-right: 0 !important;
}

.contenedor {
  position: relative;
 
}

.contenedor-ligas {
  position: relative;
}


.contenedor-logo {
  position: relative;

}

.vertical-center {
  margin: 0;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  position: absolute;
  list-style: none;

}

img {
    width: 75%;
}

.disminuir-fuente {
    font-size: .7rem;
}

p {
    margin-top: 10px;
}

.aling-item-right {
    margin-top: auto; 
    display: flex; 
    margin-left: auto; 
    justify-content: flex-end;
}

#inferior-menu .row {
  margin-left: 1 !important;
  margin-right: 1 !important;
}

#inferior-menu [class*="col-"] {
  padding-left: 1 !important;
  padding-right: 1 !important;
}

  @media only screen and (max-width:768px){
 .logo {
      width: 20%;
    }
.separador{
    border-right: none;
}

.contenedor-logo {
text-align: center;
height: 60% !important;  
right: 40px; 
display: none;
}

.contenedor {
  position: relative;

}
.contenedor-ligas{
    margin-left: 1em;
}


}


  @media (max-width: 600px) {
    .logo {
      width: 30%;
     
    }
.separador{
    border-right: none;
}

.contenedor-logo {
text-align: center;
height: 60% !important;
right: 40px;
display: none;

}
.contenedor-ligas{
    margin-left: 1em;
}

    
  }
</style>



// WEBPACK FOOTER //
// src/components/Micrositios/Comun/MenuInferiorMicrositio.vue